const PlaceholderMessage = ({ text = 'There was an error' }) => (
    <p className="placeholder-message">{text}</p>
);

export default PlaceholderMessage;
